import { AnyAction } from 'redux';
import { PaginatedResponse } from '@synergy/api';
import { Tag } from '@synergy/models';

import {
    CANCEL_DEMAND_TAGS_REQUEST,
    CANCEL_TAGS_REQUEST,
    CONFIGURATION_TAGS_RECEIVED,
    CONFIGURATION_TAGS_REQUESTED,
    CONFIGURATION_TAGS_REQUEST_CANCELED,
    CONFIGURATION_TAG_CREATED,
    CONFIGURATION_TAG_DELETED,
    CONFIGURATION_TAG_UPDATED,
    RECEIVE_DEMAND_TAGS,
    RECEIVE_TAGS,
    REQUEST_DEMAND_TAGS,
    REQUEST_TAGS,
} from '../actions/tag-actions';
import { ConfigurationTag } from '../../features/configuration/data/tags/models/configuration-tag';

export interface TagReducerState {
    demandTags: Tag[];
    tags: Tag[];
    configurationTags: PaginatedResponse<ConfigurationTag>;
    requesting: boolean;
}

const initialTagReducerState: TagReducerState = {
    demandTags: [],
    tags: [],
    configurationTags: { items: [], limit: 10, page: 0, total: 0 },
    requesting: false,
};

export const tagReducer = (state: TagReducerState = initialTagReducerState, action: AnyAction): TagReducerState => {
    const { type, ...rest } = action;
    switch (type) {
        case REQUEST_TAGS: {
            return {
                ...state,
                requesting: true,
            };
        }

        case RECEIVE_TAGS: {
            return {
                ...state,
                tags: rest['tags'],
                requesting: false,
            };
        }

        case CANCEL_TAGS_REQUEST: {
            return {
                ...state,
                requesting: true,
            };
        }

        case REQUEST_DEMAND_TAGS: {
            return {
                ...state,
                requesting: true,
            };
        }

        case RECEIVE_DEMAND_TAGS: {
            return {
                ...state,
                demandTags: rest['tags'],
            };
        }

        case CANCEL_DEMAND_TAGS_REQUEST: {
            return {
                ...state,
                requesting: false,
            };
        }

        case CONFIGURATION_TAGS_REQUESTED: {
            return {
                ...state,
                requesting: true,
            };
        }

        case CONFIGURATION_TAGS_RECEIVED: {
            return {
                ...state,
                configurationTags: rest['configurationTags'],
                requesting: false,
            };
        }

        case CONFIGURATION_TAGS_REQUEST_CANCELED: {
            return {
                ...state,
                requesting: false,
            };
        }

        case CONFIGURATION_TAG_CREATED: {
            return {
                ...state,
                configurationTags: {
                    ...state.configurationTags,
                    items: [rest['configurationTag'], ...state.configurationTags.items],
                    total: state.configurationTags.total + 1,
                },
            };
        }

        case CONFIGURATION_TAG_DELETED: {
            return {
                ...state,
                configurationTags: {
                    ...state.configurationTags,
                    items: state.configurationTags.items.filter(tag => tag.id !== rest['id']),
                    total: state.configurationTags.total - 1,
                },
            };
        }

        case CONFIGURATION_TAG_UPDATED: {
            return {
                ...state,
                configurationTags: {
                    ...state.configurationTags,
                    items: state.configurationTags.items.map(tag => {
                        if (tag.id === rest['tag'].id) {
                            return rest['tag'];
                        }
                        return tag;
                    }),
                },
            };
        }

        default: {
            return state;
        }
    }
};
